/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 671
// module chunks = 3 4 5